import { UntypedFormControl, ValidationErrors } from "@angular/forms";

/** Custom validators for the FGB application */
export class FGBValidators{

    public static Empty(control: UntypedFormControl): ValidationErrors | null {
        if( control.value && control.value.trim() === '' ){
            return { 
                empty: true 
            };
        }
        return null;
    }
}